import { useCurrentUser } from 'components/providers'
import { isEqual } from 'lodash-es'
import { createContext, useState } from 'react'
import { useParams } from 'react-router'
import { DCFilter, IEvent } from 'types'
import { FetchStatus, deleteDoc, updateDoc, useDoc } from 'utils'
import { useEvents, useMutateEventRecords } from '../../utils/eventUtils'

export interface EventContextProps {
  deleteEvent?: () => Promise<void>
  event: IEvent | null
  imageUrl?: string
  status: FetchStatus
  filters?: DCFilter[]
  setFilters: (filters: DCFilter[]) => void
  updateEvent: (body: Partial<IEvent>) => Promise<void>
}

export const EventContext = createContext<EventContextProps>({} as any)

export function EventProvider({ children }: { children: any }) {
  const id = useParams().id
  const user = useCurrentUser()
  const { events } = useEvents()
  const { updateEventRecord, removeEventRecord } = useMutateEventRecords()
  const [event, status] = useDoc('events', id)
  const [filters, setFilters] = useState<DCFilter[]>()

  const eventRecord = events?.find(e => e.id === id)

  async function updateEvent(body: Partial<IEvent>) {
    if (!user || !event) return
    const updated = await updateDoc(user.id, 'events', { id: event.id, ...body })
    updateEventRecord(updated)
  }

  async function deleteEvent() {
    if (!user || !event) return
    await deleteDoc('events', event.id)
    removeEventRecord(event.id)
  }

  function handleFiltersUpdate(newFilters: DCFilter[]) {
    const needsUpdate = !isEqual(filters, newFilters)
    if (needsUpdate) setFilters(newFilters)
  }

  return (
    <EventContext.Provider
      value={{
        deleteEvent,
        event: event || null,
        imageUrl: eventRecord?.imageUrl,
        status,
        updateEvent,
        filters,
        setFilters: handleFiltersUpdate,
      }}
    >
      {children}
    </EventContext.Provider>
  )
}
